import { RootState } from 'store';

export const selectMenu = (state: RootState) => state.menu.openDrawer;
export const selectTabName = (state: RootState) => state.menu.tabName;
